import { render, staticRenderFns } from "./GradeSalaryModal.vue?vue&type=template&id=27b27ce2&"
import script from "./GradeSalaryModal.vue?vue&type=script&lang=js&"
export * from "./GradeSalaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports